import { render } from "./CancerReservation.vue?vue&type=template&id=2801a7ec"
import script from "./CancerReservation.vue?vue&type=script&lang=js"
export * from "./CancerReservation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__